import React, { useState } from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import DateSelector from "../Common/DateSelector";
import moment from "moment";
import TimeSelector from "../Common/TimeSelector";
import { dateFormat } from "../Common/DateAndTimeFormat";

const ChatSummaryDetailsFormModal = ({ data, closePopup, onSubmit }) => {
  const [formData, setFormData] = useState(data);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    if (
      name == "fromDate" &&
      formData?.toDate &&
      moment(formData?.toDate, "D/M/YYYY").isSameOrBefore(
        moment(dateFormat(value), "D/M/YYYY"),
        "date"
      )
    ) {
      setFormData((p) => ({
        ...p,
        fromDate: dateFormat(value),
        toDate: "",
      }));
    } else {
      setFormData((p) => ({
        ...p,
        [name]:
          name == "time" && value ? value : value ? dateFormat(value) : "",
      }));
    }
  };

  return (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header ">
            <h1 className="modal__header--title">Summary Details</h1>
            <p className="para">
              Please provide the details to chat view summary
            </p>
            <button
              className="btn btn__transparent btnClose"
              onClick={closePopup}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="fromDate" className="form__label">
                    From Date<sup className="form__label__asterisk">*</sup>
                  </label>
                  <DateSelector
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleChange}
                    placeholder="DD/MM/YYYY"
                    maxDate={moment()}
                  />
                </div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="toDate" className="form__label">
                    To Date<sup className="form__label__asterisk">*</sup>
                  </label>
                  <DateSelector
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleChange}
                    placeholder="DD/MM/YYYY"
                    minDate={
                      formData.fromDate
                        ? moment(formData.fromDate, "DD/MM/YYYY")
                        : undefined
                    }
                    maxDate={moment()}
                  />
                </div>
              </div>
            </div>
            <div className="formRow mb_0">
              <div className="form__Field">
                <label for="time" className="form__label">
                  Time
                </label>
                <TimeSelector
                  type="time"
                  id="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  placeholder="--:--"
                />
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={closePopup}>
                Cancel
              </button>
              <button
                disabled={!formData?.fromDate || !formData?.toDate}
                className="btn btn__primary"
                onClick={() => onSubmit(formData)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default ChatSummaryDetailsFormModal;
